import { getFileExtension } from '@/utils/fileValidation';

export type PreviewTier =
  | 'image'
  | 'pdf'
  | 'text'
  | 'csv'
  | 'docx'
  | 'spreadsheet'
  | 'download-only';

const MIME_TO_TIER: Record<string, PreviewTier> = {
  'image/jpeg': 'image',
  'image/png': 'image',
  'image/gif': 'image',
  'image/webp': 'image',
  'application/pdf': 'pdf',
  'text/plain': 'text',
  'text/csv': 'csv',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    'docx',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
    'spreadsheet',
  'application/vnd.ms-excel': 'spreadsheet',
};

const EXTENSION_TO_TIER: Record<string, PreviewTier> = {
  jpg: 'image',
  jpeg: 'image',
  png: 'image',
  gif: 'image',
  webp: 'image',
  pdf: 'pdf',
  txt: 'text',
  csv: 'csv',
  docx: 'docx',
  xlsx: 'spreadsheet',
  xls: 'spreadsheet',
};

export function getPreviewTier(
  contentType: string,
  fileName: string
): PreviewTier {
  const mimeTier = MIME_TO_TIER[contentType];
  if (mimeTier) {
    return mimeTier;
  }
  const extension = getFileExtension(fileName);
  return EXTENSION_TO_TIER[extension] ?? 'download-only';
}
